
import api from '@/api/co.api'

const imSession = {
  getParams ({
    chatUserId = '',
    search = '',
    searchType = '',
    currentPage = '1',
    pageSize = '10',
    sort = 'update_time',
    order = 'desc',
    caches = [],
    executing = null,
    executed = null
  }) {
    const me = this
    const obj = {
      url: `${api.url.web_im_session_record}`,
      data: {
        chatUserId,
        search,
        searchType,
        currentPage,
        pageSize,
        sort,
        order
      },
      items: caches || [], // 保存已请求到的数据
      reload: false, // 数据是否重新加载
      loadType: 0,
      total: 0,
      executing, // 请求前执行
      executed, // 请求后执行
      transform: me.convertItems
    }

    return obj
  },
  delete ({
    id,
    executing = null,
    executed = null
  }) {
    api.httpx.delete({
      url: api.url.web_im_session_delete,
      id,
      executing,
      executed
    })
  },
  convertItem (srcItem) {
    return {
      ...srcItem
    }
  },
  convertItems (params, srcItems) {
    srcItems.forEach(item => {
      const dstItem = imSession.convertItem(item, false)
      params.items.push(dstItem)
    })
    return params.items.length
  }
}

export default imSession
